import { CountryCode, isSupportedCountry } from 'libphonenumber-js';

const STORAGE_PREFIX = 'rpis.dialler.country';

export const DEFAULT_DIALLER_COUNTRY: CountryCode = 'GB';

const resolveStorageKey = (tenantCode?: string, userId?: string) => {
  if (!userId) return null;

  return `${STORAGE_PREFIX}.${tenantCode || 'unknown'}.${userId}`;
};

export const getStoredDiallerCountry = (tenantCode?: string, userId?: string): CountryCode | undefined => {
  try {
    const key = resolveStorageKey(tenantCode, userId);
    if (!key || typeof localStorage === 'undefined') return undefined;

    const value = localStorage.getItem(key);
    if (value && isSupportedCountry(value)) return value;
  } catch {
    return undefined;
  }

  return undefined;
};

export const setStoredDiallerCountry = (countryCode: CountryCode, tenantCode?: string, userId?: string) => {
  try {
    const key = resolveStorageKey(tenantCode, userId);
    if (!key || typeof localStorage === 'undefined') return;
    if (!isSupportedCountry(countryCode)) return;

    localStorage.setItem(key, countryCode);
  } catch(error) {
    console.log('Error in setStoredDiallerCountry', error);
  }
};
